import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Plan } from 'src/app/models/plan.model';
import { BaseService } from '../base.service';
import { Observable } from 'rxjs';
import { Respuesta } from 'src/app/models/respuesta';
import { map, tap, catchError } from 'rxjs/operators';
import { CONFIG, HTTPOPTIONS } from 'src/app/common/constants';

@Injectable({
  providedIn: 'root'
})
export class PlanService extends BaseService<Plan> {

  private planUrl = `${environment.apiBaseUrl}/plan`;

  constructor(private http: HttpClient) {
    super('PlanService');
  }

  public findAll(): Observable<Plan[]> {
    return this.http.get<Plan[]>(`${this.planUrl}/listar`).pipe(
      map(res => res['planes']),
      tap(_ => this.log('fetched planes')),
      catchError(this.handleError('getPlanes'))
    );
  }

  public add(data: Plan): Observable<Respuesta> {
    return null;
  }

  public update(data: Plan): Observable<Respuesta> {
    return null;
  }

  public delete(id: number): Observable<Respuesta> {
    return null;
  }

  public detallePlan(): Observable<any[]> {
    return this.http.get<any[]>(`${this.planUrl}/detalleplan`).pipe(
      map(res => res['detalle']),
      tap(_ => this.log('fetched detalle plane')),
      catchError(this.handleError('detallePlan'))
    );
  }

}
